import { locale, storeKey } from "src/config/app-config";
import { useFeatureFlags } from "src/hooks/useFeatureFlags";
import currencyMap from "src/utils/currencyMap";
import { getCurrencySymbol } from "src/utils/getCurrencySymbol";
import { formatStandardPrice } from "src/utils/ct/priceHelper";
import { Money } from "src/types/ctgraphql.d";

const FRACTION_DIGITS = 2;

export const useFreeShippingThreshold = (): Money | undefined => {
  const { freeShippingThreshold } = useFeatureFlags();

  const map = (freeShippingThreshold ?? {}) as Record<string, number>;
  const threshold = map[storeKey];

  if (typeof threshold !== "number") return undefined;

  return {
    type: "centPrecision",
    currencyCode: currencyMap[locale] || "EUR",
    centAmount: Math.round(threshold * 10 ** FRACTION_DIGITS),
    fractionDigits: FRACTION_DIGITS,
  } as Money;
};

export const useFreeShippingThresholdLabel = (): string | undefined => {
  const money = useFreeShippingThreshold();

  if (!money) return undefined;

  return `${getCurrencySymbol(locale)} ${formatStandardPrice(money)}`;
};
